import type { ReactNode } from "react";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import BackTop from "@/components/feature/BackTop";

export default function MainLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <BackTop />
    </div>
  );
}